import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "46",
  height: "41",
  fill: "none"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M1.869 2.308V38.64h21.87c13.207 0 20.394-6.21 20.394-18.213 0-12.336-7.79-18.12-20.393-18.12zM23.739.422C43.109.422 46 12.957 46 20.428c0 12.96-7.904 20.099-22.26 20.099H0V.422zM4.804 23.097h7.002v12.58H4.803zm7.85-6.335a4.4 4.4 0 0 1-1.274 3.105 4.33 4.33 0 0 1-3.076 1.286 4.33 4.33 0 0 1-3.077-1.286 4.4 4.4 0 0 1-1.274-3.105c0-1.165.459-2.282 1.274-3.105a4.33 4.33 0 0 1 3.077-1.286 4.33 4.33 0 0 1 3.076 1.286 4.4 4.4 0 0 1 1.275 3.105m2.676-2.045v4.101h1.246c.863 0 1.662-.251 1.662-2.083 0-1.787-.887-2.018-1.662-2.018zm20.796-2.039h2.019v6.14h2.99C40.314 7.68 31.63 5.273 23.742 5.273h-8.41v7.41h1.245c2.268 0 3.68 1.553 3.68 4.052 0 2.579-1.378 4.118-3.68 4.118h-1.246v14.828h8.41c12.827 0 17.291-6.01 17.448-14.828h-5.06v-8.177zM30.51 17.24h1.457l-.667-2.312h-.12l-.671 2.312zm-3.149 3.617 2.442-8.179h2.87l2.441 8.177h-2.098l-.459-1.582H29.92l-.46 1.582H27.36zm-.968-2.039v2.035h-4.989v-8.17h4.829v2.034H23.42v.948h2.658v2.031h-2.656v1.122z"
    }, null, -1)
  ])))
}
export default { render: render }